import { render, staticRenderFns } from "./SidebarItemDropdown.vue?vue&type=template&id=1d7fe8b0&scoped=true"
import script from "./SidebarItemDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./SidebarItemDropdown.vue?vue&type=style&index=0&id=1d7fe8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7fe8b0",
  null
  
)

export default component.exports